const bindedLabels = document.querySelectorAll('[data-binded-label]')

bindedLabels.forEach((container) => {
  try {
    const targetElement = document.querySelector(container.dataset.bindedLabel)
    if (!targetElement) {
      throw new Error(`Target element not found for data-binded-label: ${container.dataset.bindedLabel}`)
    }

    container.addEventListener('click', (event) => {
      const clickedElement = event.target.closest('[data-label]')
      if (!clickedElement) {
        return
      }

      const dataLabel = clickedElement.dataset.label

      targetElement.textContent = dataLabel
    })
  } catch (error) {
    console.error(error)
  }
})
